<template>
  <div class="wrapper-page">
    <Auth v-if="type === 'AUTH'" @redirect="handleRedirect"></Auth>
    <Login v-else-if="type === 'LOGIN'" @redirect="handleRedirect"></Login>
    <LostPassword v-else-if="type === 'LOST_PASSWORD'" @redirect="handleRedirect"></LostPassword>
    <Approve v-else-if="type === 'APPROVE'" @redirect="handleRedirect"></Approve>
    <Register v-else-if="type === 'REGISTER'" @redirect="handleRedirect"></Register>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { auth } from '@/store';
import utils from '@/utils';
import Auth from './components/Auth.vue';
import Login from './components/Login.vue';
import LostPassword from './components/LostPassword.vue';
import Approve from './components/Approve.vue';
import Register from './components/Register.vue';

import { PAGE_TYPE_AUTH, PAGE_TYPE_APPROVE } from './pageType';

interface IState {
  type: string;
}

export default defineComponent({
  name: 'Connect',
  data() {
    return {
      type: '',
    } as IState;
  },
  components: {
    Auth,
    Login,
    LostPassword,
    Approve,
    Register,
  },
  methods: {
    handleRedirect(type: string) {
      this.type = type;
    },
  },
  mounted() {
    if (!auth.token) {
      this.type = PAGE_TYPE_AUTH;
    } else {
      this.type = PAGE_TYPE_APPROVE;
    }
    document.getElementsByTagName('body')[0].style.minWidth = 'auto';
    const frameScript = document.createElement('script');
    frameScript.setAttribute(
      'src',
      '/home/lib/iframe-resizer-3.6.3/iframeResizer.contentWindow.min.js',
    );
    document.head.appendChild(frameScript);
    utils.loading(false);
  },
});
</script>
